import { render, staticRenderFns } from "./StoreLocatorCompanyCard.vue?vue&type=template&id=e946618e&scoped=true&"
import script from "./StoreLocatorCompanyCard.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorCompanyCard.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorCompanyCard.vue?vue&type=style&index=0&id=e946618e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e946618e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
